<template>
  <div class="banner" :style="'background-image: url(\'' + image + '\')'"></div>
</template>

<script>
export default {
  name: 'ComponentContentBanner',
  components: {},
  computed: {},
  props: {
    image: String,
  },
  data() {
    return {};
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/content/_banner.scss';
</style>